/* eslint-disable import/no-cycle */
import {action, decorate, observable} from 'mobx';
import {EntityStore, LoadStrategies} from './entityStore';
import {Api} from '../middleware/api';
import {interruptionsEndpoint} from '../middleware/endpoints/stateHistories';

export class StateHistoryStore extends EntityStore {
  stateHistories = []; // not used
  stateHistoryOfWorkplace = {workplace: null, workplaceStateLogs: [], operationStateLogs: [], personnelLogs: []};
  stateHistoryOfHierarchyWorkplaces = [{workplace: null, workplaceStateLogs: [], operationStateLogs: []}];
  interruptionStateHistory = [];

  constructor(rootStore) {
    super(rootStore, 'stateHistories', Api.stateHistories, null);
  }

  loadStateHistoriesByWorkplace({workplaceId, from, to}, saveInStores = false) {
    this.stateHistoryOfWorkplace = {workplace: null, workplaceStateLogs: [], operationStateLogs: [], personnelLogs: []};
    return this.loadAll({
      params: {from, to, workplaceId},
      raw: true,
      strategy: LoadStrategies.replace,
    }).then(async (stateHistories) => {
      this.stateHistoryOfWorkplace = stateHistories.data
        .find((stateHistory) => stateHistory.workplace.id === workplaceId);

      if (saveInStores && this.stateHistoryOfWorkplace) {
        await this.rootStore.operationStore
          .loadManyWithDependencies(this.stateHistoryOfWorkplace.operationStateLogs.map((log) => log.operationId));
        this.stateHistoryOfWorkplace.operationStateLogs.forEach((log) => {
          if (log.interruptionReasonId) {
            this.rootStore.interruptionReasonStore.loadWithDependencies(log.interruptionReasonId, {onlyIfEmpty: true});
          }
        });
        const operationEntities = this.stateHistoryOfWorkplace.operationStateLogs
          .map((log) => this.rootStore.operationStateLogStore.createModelInstance(log));
        this.rootStore.operationStateLogStore.addAll(operationEntities);

        this.stateHistoryOfWorkplace.workplaceStateLogs.forEach((log) => {
          if (log.interruptionReasonId) {
            this.rootStore.interruptionReasonStore.loadWithDependencies(log.interruptionReasonId, {onlyIfEmpty: true});
          }
        });
        const workplaceEntities = this.stateHistoryOfWorkplace.workplaceStateLogs
          .map((log) => this.rootStore.workplaceStateLogStore.createModelInstance(log));
        this.rootStore.workplaceStateLogStore.addAll(workplaceEntities);

        this.stateHistoryOfWorkplace.personnelLogs.forEach((log) => {
          this.rootStore.personnelLogStore.add(this.rootStore.personnelLogStore.createModelInstance(log));
        });
      }
      return this.stateHistoryOfWorkplace;
    });
  }

  loadStateHistoriesByHierarchy({hierarchyId, from, to}) {
    return this.loadAll({
      params: {from, to, hierarchyId},
      raw: true,
    }).then((response) => {
      const hierarchyWorkplaces = response.data;
      hierarchyWorkplaces.forEach((stateHistoryOfWorkplace) => {
        this.rootStore.operationStore.loadManyWithDependencies(
          stateHistoryOfWorkplace.operationStateLogs.map((log) => log.operationId)
        );
      });
      this.stateHistoryOfHierarchyWorkplaces = hierarchyWorkplaces;
    });
  }

  loadInterruptionHistory({
    workplaceId,
    hierarchyIds,
    fromDate,
    toDate,
    materialId,
    orderId,
    isQuickstop,
    ignoreOperation,
    ignoreWorkplace,
  }) {
    return this.api[interruptionsEndpoint]({
      params: {
        workplaceId,
        hierarchyIds,
        fromDate,
        toDate,
        materialId,
        orderId,
        isQuickstop,
        ignoreOperation,
        ignoreWorkplace,
      },
    }).then((response) => {
      const data = response.data?.map((d) => this.rootStore.operationStateLogStore.createModelInstance(d));
      this.interruptionStateHistory = data || [];
    }).catch((e) => this.handleApiError(e, interruptionsEndpoint));
  }
}

decorate(StateHistoryStore, {
  loadStateHistoriesByWorkplace: action,
  loadStateHistoriesByHierarchy: action,
  loadInterruptionHistory: action,
  stateHistoryOfWorkplace: observable,
  stateHistoryOfHierarchyWorkplaces: observable,
  interruptionStateHistory: observable,
});
